import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';

const apiUrl = process.env.REACT_APP_API_URL || '';

export default function PrivacyPolicy() {
    const [emailContact, setEmailContact] = React.useState<string>('');

    useEffect(() => {
        // Substitua pela URL real do seu endpoint
        fetch(`${apiUrl}/public/info`)
            .then(async (res) => {
                const resJson = await res.json();
                if (!res.ok) {
                    console.error('Erro na resposta da API: ', resJson);
                    return Promise.reject(resJson.message || 'Ocorreu um erro desconhecido.');
                }
                return resJson;
            })
            .then((data) => {
                setEmailContact(data['professionalEmail'] || '');
            })
            .catch((err) => {
                console.error('Erro ao carregar informações:', err);
                //alert('Erro ao carregar links sociais: ' + err);
                setEmailContact('');
            });
    }, []);

    return (
        <Container>
            <section>
                <h2>Política de Privacidade</h2>

                <h3>1. Introdução</h3>
                <p>
                    Este site respeita a privacidade dos seus usuários e adota todas as medidas necessárias para proteger os dados pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD).
                </p>
                <p>Ao utilizar este site, você concorda com os termos desta Política de Privacidade.</p>

                <hr />

                <h3>2. Cookies e Armazenamento Local</h3>
                <p>
                    Este site utiliza cookies e armazenamento local para melhorar a experiência do usuário, com total respeito à sua privacidade e segurança.
                </p>

                <h4>2.1 Cookie refresh_token</h4>
                <ul>
                    <li>Armazena o token de atualização (refresh token) de forma segura, permitindo renovar o token de acesso sem que o usuário precise fazer login novamente.</li>
                    <li>O cookie é definido como <strong>HttpOnly</strong> e não pode ser acessado via JavaScript, protegendo-o contra ataques XSS.</li>
                    <li>Possui duração de aproximadamente 7 dias, expirando automaticamente após esse período ou em caso de logout.</li>
                </ul>

                <h4>2.2 access_token (armazenado via localStorage)</h4>
                <ul>
                    <li>O token de acesso (access token) é armazenado no <strong>localStorage</strong> para autenticar requisições durante a sessão do usuário.</li>
                    <li>Possui duração curta (ex.: 15 a 60 minutos) e deve ser renovado periodicamente via refresh token.</li>
                    <li>Não armazena dados pessoais sensíveis, apenas o token necessário para autenticação.</li>
                </ul>

                <h4>2.3 Cookie_consent (armazenado via localStorage)</h4>
                <ul>
                    <li>Registra a preferência do usuário quanto ao consentimento para uso de cookies.</li>
                    <li>Armazenado indefinidamente até que o usuário altere ou remova manualmente.</li>
                    <li>Armazena apenas a informação sobre aceitação do consentimento, sem dados pessoais.</li>
                </ul>

                <hr />

                <h3>3. Coleta e Uso de Dados Pessoais</h3>
                <p>
                    Este site não realiza coleta automática de dados pessoais além do necessário para manter a sessão ativa quando aplicável. Os dados são tratados de forma segura e utilizada apenas para as finalidades específicas informadas.
                </p>

                <hr />

                <h3>4. Direitos do Usuário</h3>
                <p>
                    Em conformidade com a LGPD, o usuário tem o direito de acessar, corrigir, excluir seus dados pessoais, bem como de retirar consentimentos e exercer outros direitos previstos na legislação vigente.
                </p>

                <hr />

                <h3>5. Segurança dos Dados</h3>
                <p>
                    Adotamos medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados, perdas ou alterações.
                </p>

                <hr />

                <h3>6. Atualizações da Política</h3>
                <p>
                    Esta Política de Privacidade pode ser atualizada periodicamente. Recomendamos que o usuário consulte esta página regularmente para se manter informado.
                </p>

                <hr />

                <h3>7. Contato</h3>
                <p>
                    Para dúvidas, solicitações ou para exercer seus direitos, entre em contato pelo e-mail: <a href={`mailto:${emailContact}`}>{emailContact}</a>
                </p>
            </section>
        </Container>
    );
}
